export default __webpack_public_path__ + "static/media/005.f8e66b29.jpg";